import { useEffect } from 'react';
import { useAppStore } from '../../app/store/useAppStore';

export function Notice() {
  const notice = useAppStore((state) => state.notice);
  const setNotice = useAppStore((state) => state.setNotice);
  useEffect(() => {
    if (!notice) return;
    const timer = window.setTimeout(() => setNotice(null), typeof notice === 'string' ? 3200 : 8000);
    return () => window.clearTimeout(timer);
  }, [notice, setNotice]);
  if (!notice) return null;
  const message = typeof notice === 'string' ? notice : notice.message;
  return <div className="notice" role="status">
    <span className="status-dot"/><span className="notice-message">{message}</span>
    {typeof notice === 'string' ? null : <button className="notice-action" type="button" onClick={() => { setNotice(null); notice.onAction(); }}>{notice.actionLabel}</button>}
  </div>;
}
